import { Component, Vue,} from 'vue-property-decorator'
import SalesResultMonthly from './ShippingDestinationMonthlySales/ShippingDestinationMonthlySales.vue'
import ShippingDestinationGroupSales from './ShippingDestinationGroupSales/ShippingDestinationGroupSales.vue'
import SalesResultList from './SalesResultList/SalesResultList.vue'
import SalesResultByCrop from './SalesResultByCrop/SalesResultByCrop.vue'

@Component({
    components: {
        SalesResultMonthly,
        ShippingDestinationGroupSales,
        SalesResultList,
        SalesResultByCrop
    }
})
export default class SalesResult extends Vue {
    navItem = "monthly"

    mounted() {
        this.$watch('$store.getters.currentPageName', this.currentMenu, { immediate: true });
    }

    currentMenu(){
        const path = this.$route.path
        const pathList = path.split('/')
        this.navItem = pathList[3]
    }
}